module.exports = "/_next/static/images/LALogo-1d6499ee6399dbc2ccae73ba40955a89.png";